'use client';

import { ReactNode } from 'react';

import { T } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import { Styles, css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import * as Accordion from '../../shared/faq-accordion/accordion';
import { zendesk } from '../../shared/zendesk/url';

interface Props {
  css?: Styles;
}

interface FaqItem {
  id: number;
  question: ReactNode;
  answer: ReactNode;
}
const faqItems: FaqItem[] = [
  {
    id: 1,
    question: <T id='Vip.r260121.How_can_I_become_a_flipster_vip' />,
    answer: <T id='Vip.r260121.You_can_apply_on_this_VIP_page_by_submitting_your_trading_or_asset_proof' />,
  },
  {
    id: 2,
    question: <T id='Vip.r260121.How_long_does_it_take_to_review_my_vip_application' />,
    answer: <T id='Vip.r260121.Our_VIP_team_will_review_your_information_as_soon_as_possible' />,
  },
  {
    id: 3,
    question: <T id='Vip.r260121.When_will_my_VIP_fee_discounts_start' />,
    answer: <T id='Vip.r260121.Once_your_VIP_tier_is_approved_and_upgraded' />,
  },
  {
    id: 4,
    question: <T id='Vip.r260121.How_can_I_talk_to_a_live_VIP_consultant' />,
    answer: <T id='Vip.r260121.You_can_start_a_chat_directly_from_this_page_using_the_official_Telegram' />,
  },
  {
    id: 5,
    question: <T id='Vip.r260121.Will_applying_for_VIP_change_anything_on_my_account_right_away' />,
    answer: <T id='Vip.r260121.No_Your_current_fees_and_limits_stay_the_same_until_your_VIP_tier' />,
  },
  {
    id: 6,
    question: <T id='Vip.r260121.VIP_Program_Terms_Conditions' />,
    answer: (
      <div>
        <T id='Vip.r260121.You_can_find_details_on_VIP_eligibility_benefits_and_program_conditions_here' />{' '}
        <TextButton
          as='a'
          color='accent'
          size='large'
          label='Learn more'
          href={zendesk.getZendeskExternalUrl('VipProgram')}
          suppressHydrationWarning
        />
      </div>
    ),
  },
];

export const FaqSection = ({ css: cssProps }: Props) => {
  return (
    <section
      className={css(
        center.raw({
          flexDir: 'column',
          gap: 32,
          py: { base: 40, tablet: 96 },
          px: 16,
        }),
        cssProps,
      )}
    >
      <h2
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-5',
          textAlign: 'center',
        })}
      >
        <T id='Common.r251104.Frequently_asked_questions' />
      </h2>
      <Accordion.Root headingLevel={3} css={{ w: '100%' }}>
        {faqItems.map((item) => (
          <Accordion.Item key={item.id}>
            <Accordion.Header index={item.id}>{item.question}</Accordion.Header>
            <Accordion.Panel
              css={{
                textStyle: 'Text/L/Regular',
                color: 'content.default.level-3',
              }}
            >
              {item.answer}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </section>
  );
};
